const styles = {
  gridContainer: {
    height: '100vh', 
    maxHeight: '-webkit-fill-available',
  },
  contentContainer: {
    maxWidth: '400px', 
    width: '100%', 
    height: '100%', 
    padding: '10px', 
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'space-evenly'
  },
};

export default styles;